import axios from '@/axios-auth';

const baseUrl = '/boloes-fotos/capturas';

const erroHttp = response => {
  const error = response && response.error;
  const httpResponse = error && error.response;
  const body = httpResponse && httpResponse.data;
  const status = error && (error.status || httpResponse && httpResponse.status);
  const wrapped = new Error(
    (body && body.message) || (error && error.message) || 'Não foi possível concluir a operação.'
  );
  wrapped.status = status;
  wrapped.response = httpResponse;
  return wrapped;
};

const dataDaResposta = response => {
  if (!response || response.error) throw erroHttp(response);
  return response.data && response.data.data ? response.data.data : response.data;
};

const idPath = id => `${baseUrl}/${encodeURIComponent(id)}`;

const multipart = { 'Content-Type': 'multipart/form-data' };

export default {
  criar(file, movcaixaId, idempotencyKey) {
    const form = new FormData();
    form.append('movcaixa_id', movcaixaId);
    form.append('file', file);
    return axios.post(baseUrl, form, {
      headers: { ...multipart, 'Idempotency-Key': idempotencyKey },
    }).then(dataDaResposta);
  },
  substituir(id, file) {
    const form = new FormData();
    form.append('file', file);
    return axios.post(`${idPath(id)}/substituir`, form, { headers: multipart }).then(dataDaResposta);
  },
  extrair(id, expectedRevision) {
    return axios.post(`${idPath(id)}/extracao`, {
      expected_revision: expectedRevision,
    }).then(dataDaResposta);
  },
  consultar(id) {
    return axios.get(idPath(id)).then(dataDaResposta);
  },
  consultarTentativa(idempotencyKey) {
    const keyPath = `${baseUrl}/chave/${encodeURIComponent(idempotencyKey)}`;
    return axios.get(keyPath).then(dataDaResposta);
  },
  preview(id) {
    return axios.get(`${idPath(id)}/preview`, { responseType: 'blob' }).then(dataDaResposta);
  },
  revisar(id, documento, baseRevision) {
    return axios.post(`${idPath(id)}/revisao`, {
      base_revision: baseRevision,
      document: documento,
    }).then(dataDaResposta);
  },
  lancar(id, pedido) {
    return axios.post(`${idPath(id)}/lancamento`, pedido).then(dataDaResposta);
  },
  fornecedorSugerido(id) {
    return axios.get(`${idPath(id)}/fornecedor-sugerido`).then(dataDaResposta);
  },
  situacaoEstoque(id, params) {
    return axios.get(`${idPath(id)}/situacao-estoque`, { params }).then(dataDaResposta);
  },
  descartar(id) {
    return axios.delete(idPath(id)).then(dataDaResposta);
  },
};
